/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Pack_SizeInputs */

const vi_packaging_bom_pack_size = /** @type {(inputs: Packaging_Bom_Pack_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số SP / vật tư`)
};

/**

* @param {Packaging_Bom_Pack_SizeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_pack_size = /** @type {((inputs?: Packaging_Bom_Pack_SizeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Pack_SizeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_pack_size(inputs)
});